import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {SellerServicesFactory} from '../../seller/Services/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserValueObjectsFactory from '../ValueObjects/factory.js'
import UserServicesFactory from './factory.js'

export class ContactByMailService extends Service {
  #config
  #repository
  #contactTokenValueObjectFactory
  #getContactTokenService
  #getCurrentUserService
  #saveContactDetailsService
  #saveContactTokenService

  constructor({
    config,
    repository,
    contactTokenValueObjectFactory,
    getContactTokenService,
    getCurrentUserService,
    saveContactDetailsService,
    saveContactTokenService
  }) {
    super()

    this.#config = config
    this.#repository = repository
    this.#contactTokenValueObjectFactory = contactTokenValueObjectFactory
    this.#getContactTokenService = getContactTokenService
    this.#getCurrentUserService = getCurrentUserService
    this.#saveContactDetailsService = saveContactDetailsService
    this.#saveContactTokenService = saveContactTokenService
  }

  static create({config}) {
    return new ContactByMailService({
      repository: UserRepositoriesFactory.httpUserRepository({
        config
      }),
      contactTokenValueObjectFactory: UserValueObjectsFactory.contactTokenUserValueObjectFactory,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      saveContactDetailsService: SellerServicesFactory.saveContactDetailsSellerService({config}),
      getContactTokenService: UserServicesFactory.getContactTokenUserService({
        config
      }),
      saveContactTokenService: UserServicesFactory.saveContactTokenUserService({
        config
      })
    })
  }

  @tracer({metric: 'ContactByMailService#execute'})
  @AsyncInlineError()
  async execute({
    adId,
    captchaToken,
    context,
    contractId,
    message,
    buyer,
    enrichment,
    preferences,
    isPostFavoriteLead = false,
    skipSaveContactDetails = false
  }) {
    const currentUser = await this.#getCurrentUserService.execute()

    const contact = currentUser
      ? this.#repository.contactByMailAsLoggedUser
      : this.#repository.contactByMailAsNotLoggedUser

    const [, contactTokenRetrievedVO] = await this.#getContactTokenService.execute()

    const [contactError, contactResponseVO] = await contact({
      adId,
      captchaToken,
      contactToken: contactTokenRetrievedVO.getContactToken(),
      context,
      contractId,
      message,
      buyer,
      enrichment,
      preferences,
      isPostFavoriteLead
    })

    if (contactError) {
      return Promise.reject(contactError)
    }

    const contactTokenGenerated = contactResponseVO.contactToken

    if (contactTokenGenerated) {
      const contactTokenValueObject = this.#contactTokenValueObjectFactory({
        contactToken: contactTokenGenerated
      })
      await this.#saveContactTokenService.execute({
        contactTokenValueObject
      })
    }

    if (!skipSaveContactDetails) {
      await this.#saveContactDetailsService.execute({
        adId,
        message,
        name: currentUser?.name || buyer?.name,
        email: currentUser?.email || buyer?.email,
        phone: currentUser?.phone || buyer?.phone,
        zipCode: currentUser?.zipCode || buyer?.zipCode
      })
    }

    return contactResponseVO
  }
}
